import env, {envType} from "../config/index";
import Implementation from "./implementation";


let api = {};

switch (env) {
    case envType.DEV:
        api.main = 'https://development.my-spare.com';
        api.extra = 'https://extrastaging.gotspare.com';
        api.stripe_pub_key = 'pk_test_51TnQDfAlAIHJ2Vzma6h5yfOvSL01IpU7KGPnkglgc4BYr6K5jrU0tuqnntaUM0R3i3GIOvNTAxmsMhejgawE00L5006yXPogoX';
        break;
    case envType.PROD:
        api.main = 'https://my-spare.com';
        api.extra = 'https://extra.gotspare.com';
        api.stripe_pub_key = 'pk_live_51Nxdo6APd0VBiFNTXuUC1ONMWGVo5TsNcpg3xbp3USuARVAKVEQ3gTukKujjNFZq9gp8MDmHpwl5l1ngtIqz9gJ000TdRV5fhh';
        break;
    case envType.LOCAL:
    default:
        api.main = 'http://my-spare.timdev';
        api.extra = 'http://spareextra.timdev';
        api.stripe_pub_key = 'pk_test_51TnQDfAlAIHJ2Vzma6h5yfOvSL01IpU7KGPnkglgc4BYr6K5jrU0tuqnntaUM0R3i3GIOvNTAxmsMhejgawE00L5006yXPogoX';
        break;
}

export default api;
